<script>
    import {PATH_PREFIX} from '../../../apiUrls.js';
    export let data;
    export let activity;
</script>

<span>
    {#if activity.collapsed}
        <i class="fas fa5-caret-down fa5-fw" aria-hidden="true"/>
    {:else}
        <i class="fas fa5-caret-up fa5-fw" aria-hidden="true"/>
    {/if}
</span>

<a href="{PATH_PREFIX}/sw/builder/activity/{activity.id}/" style="color: #dd5900;" target="_blank" rel="noopener noreferrer">
    {data}
</a>
